import React from 'react';
import {Button, Grid, Input, Modal} from 'semantic-ui-react';
import {ALSDSeq, ALSDComp} from "../Definitions/Alsd";
import {socket} from "../../lib/socketio";
import _ from "lodash";
import { useSelector } from 'react-redux';
import {isAuthorized } from '../../lib/authorization';
import { createUserLog } from '../../lib/api';

const ALSDColumn = ({ index, column, data}) => {

    const [tagdata, settagdata]= React.useState('');
    const [compdata, setCompdata]= React.useState('1');
    const [open, setOpen] = React.useState(false);
    const [isValidationError, setIsValidationError] = React.useState(false);
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);


    const handleOpen = (id) => setOpen({...open, [id]: true});

    const handleClose = (id) => {
        setIsValidationError(false);
        settagdata('');
        setOpen({...open, [id]:false});
    };

    const handleSubmit = (event, id, display_id) => {
        event.preventDefault();
        if(typeof tagdata === 'undefined' || tagdata === ''){
            setOpen({...open, [id]:false});
        }
        else {
            var writedata = [{'tag_id': id, 'tag_value': tagdata}];
            socket.emit('write tag', writedata);
            setOpen({...open, [id]:false});
            if (!electronApp) {
                let log = {
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: display_id,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({ tag_id: [id] }),
                };
                createUserLog({ log }).catch(console.error);
            }
        }
        settagdata('');
    }

    const handleChange = (event, value, id, min, max) => {
        event.preventDefault();
        if(event.target.value < min || event.target.value > max){
            setIsValidationError(true);
        }
        else {
            setIsValidationError(false);
            settagdata(event.target.value);
        }
    }

    const handleCheck = (event, {id}) => {
        switch(id){
            case 1:
                setCompdata(3);
                break;
            case 2:
                setCompdata(4);
                break;
            case 3:
                setCompdata(2);
                break;
            case 4:
                setCompdata(1);
                break;
            case 5:
                setCompdata(0);
                break;
            default:
                setCompdata(1);
                break;
        }
    }

    const handleComp= (event, id, display_id) => {
        event.preventDefault();
        if(typeof compdata === 'undefined' || compdata === ''){
            setOpen({...open, [id]:false});
        }
        else {
            var writedata = [{'tag_id': id, 'tag_value': compdata}];
            socket.emit('write tag', writedata);
            setOpen({...open, [id]: false});
            if (!electronApp) {
                let log = {
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: display_id,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({ tag_id: [id] }),
                };
                createUserLog({ log }).catch(console.error);
            }
        }
        setCompdata('');
    }

    // update SOFC 240321 by sumin : line 168, SOFC tag 새로 생성됨에 따라 기존 data[r.id] === data[r.id + 1] 값이 맞지 않는 경우가 있어 아래 함수 추가하여 id값 가져오는 방식으로 변경함
    const getIdbytagName = (obj, index) => {
        var seqStartId = 0;
        obj[index].map(c => c.name.slice(-5) === 'START' ? seqStartId = c.id : '');
        
        return seqStartId;
    }


    const gridColumn = _.times((1), (i) => (
        Object.keys(column).map(i => (
            <>
                <Grid columns = 'equal' inverted celled = 'internally' stackable style={styles.grid}>
                    <Grid.Column style ={styles.name} width={3}>{column[i][0].tag_display_subgroup}</Grid.Column>
                    {column[i].map(r =>
                        <Grid.Column width={(r.tag_display_name === 'DELAY/TIME') ? '3' : '2'} style = {styles.column}>
                            {r.name.slice(-4) === 'COMP' ?
                                <>
                                    <Button
                                        key = 'button'
                                        style = {styles.width}
                                        size='tiny'
                                        disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                        content = {ALSDComp(data[r.id])}
                                        onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                    <Modal
                                        key = {r.id}
                                        style = {styles.width}
                                        open = {open[r.id]}
                                        onClose={handleClose[r.id]}>
                                        <Modal.Header>Enter Value for {r.name}</Modal.Header>
                                        <Modal.Content>
                                            <Input
                                                type='checkbox'
                                                id={1}
                                                label='>'
                                                onChange={handleCheck}
                                                style={styles.checkbox1}
                                            />
                                            <Input
                                                type='checkbox'
                                                id={2}
                                                label='<'
                                                onChange={handleCheck}
                                                style={styles.checkbox1}
                                            />
                                            <Input
                                                type='checkbox'
                                                id={3}
                                                label='<>'
                                                onChange={handleCheck}
                                                style={styles.checkbox1}
                                            />
                                            <Input
                                                type='checkbox'
                                                id={4}
                                                label='ON'
                                                onChange={handleCheck}
                                                style={styles.checkbox1}
                                            />
                                            <Input
                                                type='checkbox'
                                                id={5}
                                                label='OFF'
                                                onChange={handleCheck}
                                                style={styles.checkbox1}
                                            />
                                        </Modal.Content>
                                        <Modal.Actions style={styles.toggle}>
                                            <Button color='blue' content={'Ok'}
                                                    onClick={(event, value) => handleComp(event,r.id,r.display_id)}/>
                                            <Button color='red' content={'Cancel'}
                                                    onClick ={  () => {setOpen({...open, [r.id]:false})}}/>
                                        </Modal.Actions>
                                    </Modal>
                                </>
                                :
                                r.name.slice(-3) === 'SEQ' ?
                                    <Button
                                        key='button'
                                        size='tiny'
                                        disabled
                                        content={ALSDSeq(data[r.id])}/>
                                    :
                                    // (r.name.slice(-3) === 'END' && data[r.id] === data[r.id +1]) ?
                                    (r.name.slice(-3) === 'END' && data[r.id] === data[getIdbytagName(column, i)]) ?
                                    
                                        <Button
                                            key='button'
                                            size='tiny'
                                            disabled
                                            content={data[r.id]}/>
                                        :
                                        <>
                                            <Button
                                                key = 'button'
                                                type = 'button'
                                                size='tiny'
                                                disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                                content = {data[r.id]}
                                                onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                            <Modal
                                                key = {r.id}
                                                style = {styles.width}
                                                open = {open[r.id]}
                                                onClose={handleClose[r.id]}
                                                onOpen={handleOpen[r.id]}>
                                                <Modal.Header>Enter Value for {r.name}</Modal.Header>
                                                <Modal.Content>
                                                    <form autoComplete='off'
                                                          onSubmit={(event, value) => handleSubmit(event,r.id,r.display_id)}>
                                                        <Input focus autoFocus placeholder='Value'
                                                               name='Input change'
                                                               type='number'
                                                               step='0.0001'
                                                               size='small'
                                                               min={r.min}
                                                               max={r.max}
                                                               error={isValidationError}
                                                               onChange={(event, value) => handleChange(event, value, r.id, r.min, r.max)}
                                                               defaultValue={data[r.id]}
                                                        /> {r.unit}
                                                    </form>
                                                </Modal.Content>
                                                <Modal.Actions>
                                                    <Button color='blue' content={'Ok'} disabled={isValidationError}  onClick={(event, value) => handleSubmit(event,r.id,r.display_id)}/>
                                                    <Button
                                                        key = 'button'
                                                        content = 'Close'
                                                        color = 'red'
                                                        style={{marginLeft: '5px', marginTop: '10px'}}
                                                        onClick ={  () => handleClose(r.id)}/>
                                                </Modal.Actions>
                                            </Modal>
                                            {r.tag_display_name === 'VALUE/LEVEL' ?
                                                ''
                                                :
                                                r.unit
                                            }
                                        </>
                            }
                        </Grid.Column>
                    )}
                </Grid>
            </>
        ))
    ))

    return (
        <Grid.Column>
            <Grid columns = 'equal' style ={{marginLeft: '10px'}}>
                <Grid.Row key={index} style={styles.row}>
                    <Grid.Column width={3}></Grid.Column>
                    <Grid.Column width='2' style={styles.header_color}>COMP</Grid.Column>
                    <Grid.Column width='2' style={styles.header_color}>LEVEL</Grid.Column>
                    <Grid.Column width='3' style={styles.header_color}>TIME</Grid.Column>
                    <Grid.Column width='2' style={styles.header_color}>STATE</Grid.Column>
                    <Grid.Column width='2' style={styles.header_color}>STATE START</Grid.Column>
                    <Grid.Column width='2' style={styles.header_color}>STATE END</Grid.Column>
                </Grid.Row>
                <Grid.Row key={index} style={styles.row}>
                    {gridColumn}
                </Grid.Row>
            </Grid>
        </Grid.Column>
    );
};

const styles = {
    grid: {
        margin: '0'
    },
    row: {
        maxWidth: '1500px'
    },
    name: {
        color: 'yellow',
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word'
    },
    header: {
        marginLeft: '50px',
        marginRight:'50px',
        textAlign: 'justified'
    },
    header_color: {
        color: '#05AC05',
        fontWeight: 'bold'
    },
    width: {
        maxWidth: '400px'
    },
    checkbox1: {
        flexDirection: 'row-reverse',
        marginLeft: '10px'
    },
    column: {
        paddingBottom: '0',
        width: '12%'

    }
};

export default React.memo(ALSDColumn);